import { cinemaData } from './cinema-data.js';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('cinema-showings-container');
  if (!container) return;

  let html = '';

  cinemaData.forEach((showing) => {
    // Generate locations HTML
    let locationsHtml = '';
    showing.locations.forEach((loc, index) => {
      // Escape the URL to pass it safely in a data attribute
      const safeUrl = loc.mapEmbedUrl.replace(/"/g, '&quot;');

      locationsHtml += `
        <div class="col-12 mb-3">
          <div class="card bg-dark border-gray-800 h-100 text-center p-3 cursor-pointer location-card rounded shadow-sm" data-bs-toggle="modal" data-bs-target="#locationMapModal" data-map-url="${safeUrl}">
            <h6 class="text-white mb-3 text-uppercase fw-bold fs-sm">${loc.name}</h6>
            <div class="d-flex flex-wrap justify-content-center gap-2">
              ${loc.times.map(time => `<span class="badge bg-primary text-white p-2">${time}</span>`).join('')}
            </div>
          </div>
        </div>
      `;
    });

    html += `
      <div class="col-12 col-md-6 col-lg-4 mb-6 showing-item">
        <div class="cinema-card border border-gray-800" style="background-image: url('${showing.image}');">
          <div class="cinema-card-content p-4">
            <h3 class="card-title text-white mb-2 fw-bold text-shadow">${showing.title}</h3>
            <p class="card-text text-gray-300 mb-4 fs-sm">${showing.description}</p>
            
            <a class="liquid-btn text-decoration-none d-flex align-items-center justify-content-center p-3 mb-2" data-bs-toggle="collapse" href="#collapse-${showing.id}" role="button" aria-expanded="false" aria-controls="collapse-${showing.id}">
              <span class="text-white fw-bold me-2 text-uppercase letter-spacing-lg fs-sm">Locations & Times</span>
              <i class="fe fe-chevron-down text-white fs-5"></i>
            </a>
            
            <div class="collapse mt-4" id="collapse-${showing.id}">
              <div class="row pe-md-2 desktop-scrollable">
                ${locationsHtml}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;

  // Add event listeners for location cards to populate the modal iframe
  const locationCards = document.querySelectorAll('.location-card');
  const iframe = document.getElementById('mapFrame');
  const modalLabel = document.getElementById('locationMapModalLabel');

  locationCards.forEach(card => {
    card.addEventListener('click', function () {
      const url = this.getAttribute('data-map-url');
      const name = this.querySelector('h6').textContent;

      if (iframe) {
        iframe.src = url;
      }
      if (modalLabel) {
        modalLabel.textContent = name;
      }
    });
  });

  // Handle modal hide event to clear iframe src and stop loading in background
  const locationMapModal = document.getElementById('locationMapModal');
  if (locationMapModal) {
    locationMapModal.addEventListener('hidden.bs.modal', function () {
      if (iframe) {
        iframe.src = '';
      }
    });
  }
});
